import { render, staticRenderFns } from "./WikiNav.vue?vue&type=template&id=9dcf28ac"
import script from "./WikiNav.vue?vue&type=script&lang=ts"
export * from "./WikiNav.vue?vue&type=script&lang=ts"
import style0 from "./WikiNav.vue?vue&type=style&index=0&id=9dcf28ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports